function BlogItemCpn({data}){
    const {title="",image="",desc="",category="",date=""} = data || {};


    return (
        <>
            <a href="/education/common-mistakes-to-avoid-in-copy-trading/">
                <div className="BlogsCategories_cardDiv__QGkbm">
                    <div className="BlogsCategories_upperDiv___xZ_d">
                    <div className="BlogsCategories_cardImageDiv__3cpYk">
                        <span
                        style={{
                            boxSizing: "border-box",
                            display: "inline-block",
                            overflow: "hidden",
                            width: "initial",
                            height: "initial",
                            background: "none",
                            opacity: 1,
                            border: 0,
                            margin: 0,
                            padding: 0,
                            position: "relative",
                            maxWidth: "100%"
                        }}
                        >
                        <span
                            style={{
                            boxSizing: "border-box",
                            display: "block",
                            width: "initial",
                            height: "initial",
                            background: "none",
                            opacity: 1,
                            border: 0,
                            margin: 0,
                            padding: 0,
                            maxWidth: "100%"
                            }}
                        >
                            <img
                            alt=""
                            aria-hidden="true"
                            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27768%27%20height=%27432%27/%3e"
                            style={{
                                display: "block",
                                maxWidth: "100%",
                                width: "initial",
                                height: "initial",
                                background: "none",
                                opacity: 1,
                                border: 0,
                                margin: 0,
                                padding: 0
                            }}
                            />
                        </span>
                        <img
                            alt="Explore How To Avoid Costly Mistakes In Crypto Copy Trading"
                            src={image}
                            decoding="async"
                            data-nimg="intrinsic"
                            className="BlogsCategories_image__rZgH1"
                            style={{
                            position: "absolute",
                            inset: 0,
                            boxSizing: "border-box",
                            padding: 0,
                            border: "none",
                            margin: "auto",
                            display: "block",
                            width: 0,
                            height: 0,
                            minWidth: "100%",
                            maxWidth: "100%",
                            minHeight: "100%",
                            maxHeight: "100%",
                            objectFit: "cover"
                            }}
                        />
                        </span>
                    </div>
                    <div className="BlogsCategories_cardContentDiv__cVeSs">
                        <div className="BlogsCategories_cardCategoryDiv__PAPlO">
                            {category}
                        </div>
                        <div className="BlogsCategories_cardTitleDiv__JaB2c">
                        {title}
                        </div>
                        <div className="BlogsCategories_cardDescriptionDiv__zXiQ1">
                        {desc}
                        </div>
                    </div>
                    </div>
                    <div className="BlogsCategories_lowerDiv__fAxpI">
                    <div className="BlogsCategories_cardDateDiv__vikFf">
                        {date}
                    </div>
                    </div>
                </div>
            </a>
        </>
    )
}
export default BlogItemCpn;